module.exports = __webpack_public_path__ + "static/prusaSL1S-f85ca83655c160b16988098b8a01d3bf.png";